import { render, staticRenderFns } from "./MovementsReport.vue?vue&type=template&id=0b7fd313&"
import script from "./MovementsReport.vue?vue&type=script&lang=js&"
export * from "./MovementsReport.vue?vue&type=script&lang=js&"
import style0 from "./MovementsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports